/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const EmojiIcon = ({
  className,
  style,
  color = '#9b9b9b',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 0C2.91586 0 0 2.91586 0 6.5C0 10.0841 2.91586 13 6.5 13C10.0841 13 13 10.0841 13 6.5C13 2.91586 10.0841 0 6.5 0ZM6.5 12.1875C3.36395 12.1875 0.8125 9.63605 0.8125 6.5C0.8125 3.36395 3.36395 0.8125 6.5 0.8125C9.63605 0.8125 12.1875 3.36395 12.1875 6.5C12.1875 9.63605 9.63605 12.1875 6.5 12.1875Z"
        fill={color}
      />
      <path
        d="M4.16631 5.22011C4.65296 5.22011 5.04747 4.8256 5.04747 4.33895C5.04747 3.8523 4.65296 3.45779 4.16631 3.45779C3.67966 3.45779 3.28516 3.8523 3.28516 4.33895C3.28516 4.8256 3.67966 5.22011 4.16631 5.22011Z"
        fill={color}
      />
      <path
        d="M8.83038 5.22011C9.31702 5.22011 9.71153 4.8256 9.71153 4.33895C9.71153 3.8523 9.31702 3.45779 8.83038 3.45779C8.34373 3.45779 7.94922 3.8523 7.94922 4.33895C7.94922 4.8256 8.34373 5.22011 8.83038 5.22011Z"
        fill={color}
      />
      <path
        d="M10.6739 7.42786C10.4601 7.36368 10.2328 7.48616 10.1686 7.70086C10.1615 7.72504 9.40908 10.1276 6.50155 10.1276C3.61332 10.1276 2.8648 7.79836 2.83413 7.69924C2.76913 7.48494 2.54143 7.36408 2.32916 7.42786C2.11405 7.49226 1.99198 7.71874 2.05616 7.93344C2.0653 7.96351 2.99602 10.9401 6.50155 10.9401C10.0071 10.9401 10.9378 7.96351 10.9469 7.93324C11.0111 7.71874 10.8891 7.49226 10.6739 7.42786Z"
        fill={color}
      />
    </svg>
  );
};
